import { render, staticRenderFns } from "./PollItem.vue?vue&type=template&id=61c19548&"
import script from "./PollItem.vue?vue&type=script&lang=js&"
export * from "./PollItem.vue?vue&type=script&lang=js&"
import style0 from "./PollItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports